<template>
<div>
  <div class="choose-header">
    <choose-btn :icon='iconType'></choose-btn>
    <!-- <div class="name">
      <img class="one" src="../common/image/resturantIcon-2.png" />
      <span>{{ getResturantName }}</span>
      <img class="two" src="../common/image/triangle-2.png" />
    </div> -->
  </div>
  <div class="ch-con">
    <div class="ch-list">
      <p class="s-title">支付方式 (可多选)</p>
      <ul type="payType">
        <li @click="moreChooseClick($event,'微信支付','1')">微信支付</li>
        <li @click="moreChooseClick($event,'支付宝支付','1')">支付宝支付</li>
        <li @click="moreChooseClick($event,'刷卡支付','1')">刷卡支付</li>
        <li @click="moreChooseClick($event,'现金支付','1')">现金支付</li>
        <li v-for="(itme,index) in this.backPayType" @click="moreChooseClick($event,itme,'1')" :key="index">{{ itme }}</li>
      </ul>
      <p class="s-title">支付来源 (可多选)</p>
      <ul type="paySource">
        <li @click="moreChooseClick($event,'POS机','2')">POS机</li>
        <li @click="moreChooseClick($event,'扫码点餐','2')">扫码点餐</li>
        <li @click="moreChooseClick($event,'商家后台','2')">商家后台</li>
      </ul>
      <div class="dateTtile">
         <p class="t-title">支付时间 (不支持跨年查询)</p>
         <p class="garbageTitle" @click="deleteTime()">清空时间范围 <img class="garbage" src="../common/image/garbage.png" /></p>
      </div>   
      <ul type="payTiem">
        <li @click="daySelect(0)" :class="{'active':dayFlag == 0,'':dayFlag !== 0}">近七天</li>
        <li @click="daySelect(1)" :class="{'active':dayFlag == 1,'':dayFlag !== 1}">近30天</li>
        <li @click="daySelect(2)" :class="{'active':dayFlag == 2,'':dayFlag !== 2}" class="ch-day">
          <input v-model="startSelectTime" @click="selectTimeFn(1)" placeholder="开始日期"/> -
          <input v-model="endSelectTime"  @click="selectTimeFn(2)" placeholder="结束日期"/>
        </li>
      </ul>
    </div>
  </div>
  <div class="ch-foodr box-shadow">
   <span @click="resertFn()">重置</span><span @click="confirmFn()">确定</span>
  </div>
   <mt-datetime-picker
      ref="picker"
      type="date"
      class="myPicker"
      year-format="{value} 年"
      month-format="{value} 月"
      date-format="{value} 日"
      v-model="pickerValue"
      confirmText="完成"
      cancelText=""
      @confirm="handleConfirm()"
      >
    </mt-datetime-picker>
</div>
</template>

<script>
import { DatetimePicker } from 'mint-ui'
import { Toast } from 'mint-ui'
import DataHeader from 'components/dataHeader'
import chooseBtn from 'components/chooseBtn'
import { MessageBox } from 'mint-ui'
export default {
  data() {
    return {
      name: '',
      data: [],
      payType: [],
      paySource: [],
      startSelectTime: '',
      endSelectTime: '',
      startDateFormat: new Date(),
      endDateFormat: new Date(),
      pickerValue: new Date(),
      startOrEnd: '',
      backPayType: [],
      dayFlag: -1,
      iconType: false,
      chooseIcon: require('../common/image/triangle-2.png')
    }
  },
  // 引入组件
  components: {
    DataHeader,
    chooseBtn,
    DatetimePicker
  },
    // 加载加完毕执行
  mounted() {
    this.getPayType()   // 请求支付方式
  },
  // 计算属性
  computed: {
    getResturantId: function() {
      return this.$store.state.resturantId
    },
    getResturantName: function() {
      return this.$store.state.resturantName
    }
  },
  // 方法
  methods: {
    // 请求支付方式
    getPayType() {
      const _this = this // vue对象的this 赋给 _this
      this.$http.get(this.common.url_order + '/searchAllPayType', {
        params: {
          restaurantId: _this.getResturantId,
          userId: _this.common.localGet('loginInfo').userId,
          merchantId: _this.common.localGet('loginInfo').merchantId,
          openId: _this.common.localGet('openId')
        }
      })
      .then(function(response) {
        if (response.data.code === 0) {
          // console.log(JSON.stringify(response))
          const res = response.data
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i] !== '微信支付' && res.data[i] !== '支付宝支付' && res.data[i] !== '刷卡支付' && res.data[i] !== '现金支付') {
              _this.backPayType.push(res.data[i])
            }
          }
        } else if (response.data.code === 300008) {  // 取消权限或被迫下线
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              _this.$router.push({ path: '/login' })
            }
          })
        } else {
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              console.log(response.data.msg)
            }
          })
        }
      })
      .catch(function(error) {
        console.log(error)
      })
    },
    // 多选
    moreChooseClick(e, nane, type) {
      const el = e.currentTarget
      // 点击改变样式
      if (el.className.indexOf('active') === -1) {
        el.className = 'active'
        this.getClickValue(el, nane, type)
      } else {
        el.className = ''
        this.getClickCancle(el, nane, type)
      }
    },
    // 多选点击选中执行的方法
    getClickValue(obj, nane, type) {
      if (type === '1') {
        this.payType.push(nane)
        // console.log(this.payType)
      } else if (type === '2') {
        this.paySource.push(nane)
        // console.log(this.paySource)
      } else if (type === '3') {
        this.startTime.push(nane)
        // console.log(this.startTime)
      }
    },
    // 多选取消选中执行的方法
    getClickCancle(obj, nane, type) {
      if (type === '1') {
        this.common.removeByValue(this.payType, nane)
        // console.log(this.payType)
      } else if (type === '2') {
        this.common.removeByValue(this.paySource, nane)
        // console.log(this.paySource)
      } else if (type === '3') {
        this.common.removeByValue(this.startTime, nane)
        // console.log(this.startTime)
      }
    },
     // 单选
    daySelect(dayIndex) {
      this.dayFlag = dayIndex
      if (dayIndex === 0) {
        this.startSelectTime = this.common.formatDate(new Date() - 7 * 24 * 60 * 60 * 1000) // 最近七天
        this.endSelectTime = this.common.formatDate(new Date())
      } else if (dayIndex === 1) {
        this.startSelectTime = this.common.formatDate(new Date() - 30 * 24 * 60 * 60 * 1000) // 最近30天
        this.endSelectTime = this.common.formatDate(new Date())
      } else if (dayIndex === 2) {
        // this.startSelectTime = ''
        // this.endSelectTime = this.common.formatDate(new Date())
      }
    },
    selectTimeFn(clickStyle) { // 1,点击的是开始时间 2,点击的是结束时间
      if (clickStyle === 1) {
        this.startOrEnd = 1
      } else if (clickStyle === 2) {
        this.handleConfirm()
        this.startOrEnd = 2
      }
      this.$refs.picker.open()
    },
    handleConfirm() { // 时间选择器完成 按钮
      if (this.startOrEnd === 1) { // 开始时间的确定按钮
        this.startDateFormat = this.pickerValue  // 临时保存时间戳用于比较大小、跨年等
        this.startSelectTime = this.common.formatDate(this.startDateFormat)
      } else if (this.startOrEnd === 2) {
        this.endDateFormat = this.pickerValue  // 临时保存时间戳用于比较大小、跨年等
        this.endSelectTime = this.common.formatDate(this.endDateFormat)
      }
    },
    deleteTime() { // 清空时间范围
      this.startSelectTime = ''
      this.endSelectTime = ''
      this.dayFlag = -1
    },
    resertFn() { // 重置数据
      window.location.reload() // 页面刷新
    },
    confirmFn() { // 确定
      // const data = { 'payType': this.payType, 'paySource': this.paySource, 'time': [this.startSelectTime, this.endSelectTime] }
      if (this.startSelectTime !== '' || this.endSelectTime !== '') { // 在有时间的情况下 在去比较时间，是否跨年或结束时间小于开始时间等
        const startFirst = this.startSelectTime.split('-')[0] // 截取年，用年做比较，两个年不一样，说明就跨年了
        const endFirst = this.endSelectTime.split('-')[0]
        if (startFirst !== endFirst) {
          Toast({
            message: '时间选择不能跨年',
            duration: 3000
          })
          return
        }
        if (this.endDateFormat - this.startDateFormat < 0) {
          Toast({
            message: '结束时间不能小于开始时间！',
            duration: 3000
          })
          return
        } else {
          this.$router.push({ path: '/orderList', query: { 'payType': this.payType.join(','), 'paySource': this.paySource.join(','), 'startTime': this.startSelectTime, 'endTime': this.endSelectTime }})
        }
      } else {
        this.$router.push({ path: '/orderList', query: { 'payType': this.payType.join(','), 'paySource': this.paySource.join(','), 'startTime': this.startSelectTime, 'endTime': this.endSelectTime }})
      }
    }
  }
}
</script>

<style>
  /* header 内容 */
  .choose-header {
    top: 0;
    left: 0;
    width: 100%;
    height: 0.9rem;
    position: absolute;
    line-height: 0.9rem;
    border-bottom: 1px solid #e3e4e6;
    z-index: 101;
  }
  .name {
    max-width: 4rem;
    float: right;
    text-align: right;
    padding-right: 0.2rem;
    display: inline-block;
    position: relative;
  }
  .name span {
    height: 0.9rem;
    max-width: 3.8rem;
    overflow: hidden;
    padding: 0 0.4rem 0 0.6rem;
    display: inline-block
  }
  .name .one,
  .name .two {
    top: 0;
    position: absolute;
  }
  .name .one {
    left: 0;
    top: 0.26rem;
    width: 0.38rem;
    height: 0.38rem;
  }
  .name .two {
    top: 0.35rem;
    right: 0.2rem;
  }
  /* 筛选内容 */
  .ch-con {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    padding-top: 0.9rem;
    padding-bottom: 1.2rem;
    overflow-y: hidden;
    z-index: 100;
  }
  .ch-list {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 0.3rem 0.3rem 0.3rem 0;
  }
  .s-title {
    color: #555;
    height: 0.28rem;
    font-size: 0.28rem;
    padding-left: 0.3rem;
    margin-bottom: 0.24rem;
  }
  .t-title{
    color: #555;
    height: 0.28rem;
    font-size: 0.28rem;
    padding-left: 0.3rem;
  }
  .garbageTitle{
    color:#f74d47
  }

  .garbage{
    width: 0.16rem;
    height: 0.22rem;
  }
  .dateTtile{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.24rem;
  }
  .ch-list ul {
    font-size: 0;
    margin-bottom: 0.52rem;
  }
  .ch-list li {
    width: auto;
    height: 0.6rem;
    color: #000000;
    font-size: 0.28rem;
    text-align: center;
    line-height: 0.6rem;
    background: #eeeeee;
    border-radius: 0.06rem;
    padding: 0 0.2rem;
    margin-left: 0.3rem;
    margin-bottom: 0.2rem;
    display: inline-block;
    overflow: hidden;
  }
  .ch-list li.ch-day {
    width: 6.8rem;
    height: auto;
    padding: 0.14rem;
  }
  li.ch-day input {
    width: 3rem;
    height: 0.6rem;
    text-align: center;
    border-radius: 0.06rem;
    outline: 0 none;
  }
  .ch-list li.active {
    color: #f74d47;
    position: relative;
    background: #fddbda;
  }
  .ch-list li.active::after {
    content: ''; 
    width: 0.45rem; 
    height: 0.45rem; 
    position: absolute; 
    bottom: 0rem; 
    right: 0rem;
    background-image: url('~common/image/li-active.png');
    background-size: 100% auto;
  }
  /* foodr 内容 */
  .ch-foodr {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1.2rem;
    line-height: 1.2rem;
    position: fixed;
    z-index: 101;
  }
  .ch-foodr span {
    width: 50%;
    height: 100%;
    text-align: center;
    font-size: 0.32rem;
    display: inline-block;
  }
  .ch-foodr span:first-child { 
    color: #fff;
    background: #f74d47;
  }
  .ch-foodr span:last-child {
    color: #f74d47;
  }
  .box-shadow {
    box-shadow: 0px 1px 2px 3px #e5e6e7;
  }
</style>


// WEBPACK FOOTER //
// src/components/choose.vue